export default __webpack_public_path__ + "static/media/p1000-tip-box.c2071626.svg";